import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW5300Component } from './kymw5300.component';

import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

/**
 * ECカテゴリマスタ画面 モジュール設定クラス
 *
 * @export KYMW5300Module
 * @class KYMW5300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjNavModule,
  ],
  declarations: [
    KYMW5300Component,
  ],
  providers: [
  ],
})
export class KYMW5300Module {

}
